import { useGlobalStore } from '@highlight/ipc/react'
import type { ChatRequestBody } from '../engine/services'
import { useDevMode } from '../store/runtime'

export type ReasoningEffort = NonNullable<ChatRequestBody['reasoningEffort']>

/** The user's pick in the composer. `auto` leaves the depth to each model. */
export type ReasoningEffortSetting = 'auto' | ReasoningEffort

const REASONING_EFFORT_SETTING_KEY = 'chat-reasoning-effort'

/** Developer mode only for now. */
export const useReasoningControlsEnabled = () => useDevMode()

/** Sticks across chats and windows. */
export const useReasoningEffortSetting = () =>
  useGlobalStore<ReasoningEffortSetting>('settings', REASONING_EFFORT_SETTING_KEY, 'auto')

/** The effort the next turn asks the server for. Undefined keeps the model's default. */
export function useRequestedReasoningEffort(): ReasoningEffort | undefined {
  const enabled = useReasoningControlsEnabled()
  const [setting] = useReasoningEffortSetting()
  return enabled && setting !== 'auto' ? setting : undefined
}
